import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CourseDetailComponent } from './course-detail.component';
import { TagService } from '../shared/services/tag.service';
import { CourseService } from '../shared/services/course.service';
import { SharedModule } from '../shared/shared.module';
import { CourseDetailResolve } from './course-detail.resolve';

/* Feature Modules */
import { KSSwiperModule } from 'angular2-swiper';

@NgModule({
  declarations: [
        CourseDetailComponent
  ],
  imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        KSSwiperModule
  ],
  providers: [
        TagService,
        CourseService,
        CourseDetailResolve
  ]
})

export class CourseDetailModule {}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/course-detail/course-detail.module.ts